export default __webpack_public_path__ + "static/char-56-60e313a4a9ed52c5b41681760b7f0db7.gif";